module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.existingReservationComp) ? _c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "small-h2 text-center"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Booking ID: "), _c('strong', [_vm._v(_vm._s(_vm.existingReservationComp.BookingNumber) + " ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7 remove-margins"
  }, [(_vm.existingReservationComp.CustomerStatus) ? _c('div', {
    staticClass: "alert alert-dismissible",
    class: _vm.existingReservationComp.StatusClass,
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Customer Status: ")]), _vm._v(_vm._s(_vm.existingReservationComp.CustomerStatus))])]) : _vm._e(), _vm._v(" "), (_vm.existingReservationComp.SitterStatus) ? _c('div', {
    staticClass: "alert alert-dismissible",
    class: _vm.existingReservationComp.StatusClass,
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Sitter Status: ")]), _vm._v(_vm._s(_vm.existingReservationComp.SitterStatus))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 remove-margins"
  }, [_c('h4', [_c('strong', [_vm._v("Submitted date is " + _vm._s(_vm.dateFormatter(_vm.existingReservationComp.SubmittedDate)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 remove-margins"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object img-responsive img-circle",
    attrs: {
      "src": _vm.existingReservationComp.SitterProfilePic,
      "alt": "",
      "height": "25",
      "width": "25"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-left head-title"
  }, [_c('h4', {
    staticClass: "media-heading ",
    staticStyle: {
      "padding-bottom": "0px",
      "margin-bottom": "0px"
    }
  }, [_vm._v(" Sitter Name:  "), _c('strong', [_vm._v(_vm._s(_vm.existingReservationComp.SitterName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 remove-margins"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object img-responsive img-circle",
    attrs: {
      "src": _vm.existingReservationComp.CustomerProfilePic,
      "alt": "",
      "height": "25",
      "width": "25"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-left head-title"
  }, [_c('h4', {
    staticClass: "media-heading ",
    staticStyle: {
      "padding-bottom": "0px",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Customer Name: "), _c('strong', [_vm._v(_vm._s(_vm.existingReservationComp.CustomerName))])])])])]), _vm._v(" "), _c('ChatHistory', {
    attrs: {
      "transactionId": _vm.reservationIdComp,
      "submittedDate": _vm.existingReservationComp.SubmittedDate,
      "preventChat": true
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-info btn-lg",
    on: {
      "click": function($event) {
        _vm.goBookingsDashboard()
      }
    }
  }, [_vm._v("Go to Bookings Dashboard")])], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm col-md-4 pull-right reservationSummary"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(" Summary ")]), _vm._v(" "), _vm._l((_vm.existingReservationComp.AvailablePetDtos), function(petCard) {
    return _c('div', [_c('div', [_c('PetSelectCard', {
      key: petCard.PetId,
      attrs: {
        "showDetails": true,
        "petId": petCard.PetId
      }
    })], 1)])
  }), _vm._v(" "), _c('h5', {
    staticClass: "small"
  }, [_vm._v("Total Days: " + _vm._s(_vm.existingReservationComp.TotalDays))]), _vm._v(" "), _c('h5', {
    staticClass: "small"
  }, [_vm._v("Dates: " + _vm._s(_vm.startDateComp) + " - " + _vm._s(_vm.endDateComp))]), _vm._v(" "), _vm._l((_vm.existingReservationComp.ServicePriceSummaryDtos), function(service) {
    return _c('h5', {
      staticClass: "small"
    }, [_vm._v(_vm._s(service.Description))])
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-success"
  }, [_vm._v("Total Price: " + _vm._s(_vm.totalPriceComputed) + " " + _vm._s(_vm.currencyComp))])], 2)])]) : _c('div', {
    staticClass: "container"
  }, [_vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading..")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-286974e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Components/viewReservationAdmin.vue
// module id = 618
// module chunks = 2